package pwgs.ui.scenes.projectlist

import kotlinx.serialization.Serializable
import visage.ds.forms.FieldModel
import visage.rmi.VisageController

@VisageController(ProjectListSceneProps::class, ProjectListSceneModel::class)
interface ProjectList {

    fun load()

    fun createProject()

}

@Serializable
class ProjectListSceneProps() {

}

@Serializable
class ProjectListSceneModel(
    val projects: List<ProjectListItemModel>
) {
    var isLoading = true
    var createProjectDialogModel: CreateProjectDialogModel? = null
}

@Serializable
class ProjectListItemModel(
    val id: Long,
    val name: String
)

@Serializable
class CreateProjectDialogModel(

) {
    var isLoading = false
    var error: String? = null
    var name = FieldModel("")
}